'use client';

import { useState } from 'react';

import {
  IconMicrophone01,
  IconPlayCircle,
  IconScissorsCut01,
  IconTranslate01,
} from '@kezios/design-system';
import { Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { YoutubeModal } from 'components/website/components/modals/YoutubeModal/YoutubeModal';
import { useTranslations } from 'next-intl';

import { InfoSectionLayout } from './InfoSectionLayout';

export const InfoSection = () => {
  const t = useTranslations('section.info');

  const [modalOpened, { toggle }] = useDisclosure(false);
  const [videoUrl, setVideoUrl] = useState('');
  const [title, setTitle] = useState('');

  const displayVideo = (url: string, title: string) => {
    setVideoUrl(url);
    setTitle(title);
    toggle();
  };

  return (
    <>
      {modalOpened && (
        <YoutubeModal
          isOpen={modalOpened}
          onClose={() => toggle()}
          youtubeUrl={videoUrl}
          title={title}
        />
      )}
      <InfoSectionLayout
        id="features"
        title={t('title')}
        subtitle={t('subtitle')}
        category={t('category')}
        className="section"
      >
        <InfoSectionLayout.Item
          key={'infoSecond'}
          title={t('items.timeWasted.title')}
          titleComponent={'h3'}
          description={t('items.timeWasted.description')}
          animatedTitle
          icon={<IconTranslate01 size={24} />}
          cta={
            <Button
              style={{ width: 'fit-content' }}
              leftSection={<IconPlayCircle size={20} color="gray.7" />}
              variant="oauth"
              onClick={() =>
                displayVideo(
                  t('items.timeWasted.link'),
                  t('items.timeWasted.title')
                )
              }
            >
              Demo
            </Button>
          }
          image={
            <video
              style={{ width: '100%', objectFit: 'fill' }}
              autoPlay={true}
              loop
              muted
              playsInline
            >
              <source src={'/static/captions.webm'} type="video/webm" />
              <source src={'/static/captions.mp4'} type="video/mp4" />
            </video>
          }
        />
        <InfoSectionLayout.Item
          key={'infoFirst'}
          title={t('items.timeGained.title')}
          titleComponent={'h3'}
          description={t('items.timeGained.description')}
          icon={<IconScissorsCut01 size={24} />}
          cta={
            <Button
              style={{ width: 'fit-content' }}
              leftSection={<IconPlayCircle size={20} color="gray.7" />}
              variant="oauth"
              onClick={() =>
                displayVideo(
                  t('items.timeGained.link'),
                  t('items.timeGained.title')
                )
              }
            >
              Demo
            </Button>
          }
          image={
            <video
              style={{ width: '100%' }}
              autoPlay={true}
              loop
              muted
              playsInline
            >
              <source src={'/static/timeWasted.webm'} type="video/webm" />
              <source src={'/static/timeWasted.mp4'} type="video/mp4" />
            </video>
          }
          reverse
        />

        <InfoSectionLayout.Item
          key={'infoThird'}
          title={t('items.podcast.title')}
          titleComponent={'h3'}
          description={t('items.podcast.description')}
          icon={<IconMicrophone01 size={24} />}
          cta={
            <Button
              style={{ width: 'fit-content' }}
              leftSection={<IconPlayCircle size={20} color="gray.7" />}
              variant="oauth"
              onClick={() =>
                displayVideo(t('items.podcast.link'), t('items.podcast.title'))
              }
            >
              Demo
            </Button>
          }
          image={
            <video
              style={{ width: '100%', objectFit: 'fill' }}
              autoPlay={true}
              loop
              muted
              playsInline
            >
              <source src={'/static/podcastEdit.webm'} type="video/webm" />
              <source src={'/static/podcastEdit.mp4'} type="video/mp4" />
            </video>
          }
        />
      </InfoSectionLayout>
    </>
  );
};
